<template>
  <div id="Edit">
    <h2>新闻管理</h2>
    <div class="EditTable">
      <div class="EditTable_AddBtn">
        <!-- <el-button type="success"
          ><a
            href="http://www.youyihu.cn/#/#News"
            target="_blank"
            rel="noopener noreferrer"
            >返回新闻页面</a
          >
        </el-button> -->
        <!-- <el-button type="success" @click="$router.push({ path: '/#News' })"
          >查看新闻页面</el-button
        > -->
        <el-button type="primary" @click="openAddNewsDialog()">添加</el-button>
      </div>
      <!-- 表格 -->
      <div class="EditMain">
        <el-table :data="tableData" height="100%" border row-key="id">
          <el-table-column label="编号" prop="id" align="center" width="50">
          </el-table-column>
          <el-table-column label="详情" prop="title" align="center">
          </el-table-column>
          <el-table-column
            label="日期"
            prop="startTime"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column label="编辑" width="180" align="center">
            <template slot-scope="scope">
              <el-button type="warning" @click="openChangeNewsDialog(scope.row)"
                >修改</el-button
              >
              <el-button type="danger" @click="delNews(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="EditPagination">
        <el-pagination
          :hide-on-single-page="true"
          @current-change="handleCurrentChange"
          background
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 对话框 -->
    <el-dialog
      :title="dialogTitle"
      top="4vh"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-form :model="form">
        <el-form-item label="新闻标题">
          <el-input
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 4 }"
            v-model.trim="form.title"
            placeholder="新闻标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="form.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="新闻主题">
          <Editor id="tinymce" :init="init" v-model="form.dataes"></Editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit(type)">{{
            dialogBtn
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
// import Sortable from "sortablejs";
import { getNewsList, addNews, updateNews, delNews } from "../axiosAPI";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/icons/default"; //图标
import "tinymce/plugins/image"; // 插入上传图片插件
import "tinymce/plugins/media"; // 插入视频插件
import "tinymce/plugins/table"; // 插入表格插件
import "tinymce/plugins/lists"; // 列表插件
import "tinymce/plugins/wordcount"; // 字数统计插件
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/template";
import "tinymce/plugins/preview";
import "tinymce/plugins/quickbars";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/hr";
// import "tinymce/plugins/importword";
export default {
  inject: ["reload"],
  name: "Edit",
  components: {
    Editor,
  },
  data() {
    return {
      // 表格数据
      tableData: [
        {
          startTime: "",
          title: "",
          dataes: "",
        },
      ],
      limit: 5,
      page: 1,
      total: 0,
      // dialog
      dialogVisible: false,
      dialogTitle: "",
      dialogBtn: "",
      // 表单数据
      form: {
        title: "",
        startTime: "",
        dataes: "",
      },
      // 选择的类型
      type: "",
      // 富文本编辑器
      //初始化配置
      init: {
        selector: "#tinymce",
        language_url: "/tinymce/langs/zh_CN.js",
        language: "zh_CN",
        skin_url: "/tinymce/skins/ui/oxide",
        height: 450,
        // width: "80%",
        branding: false, //是否禁用“Powered by TinyMCE”
        menubar: "file edit insert view format",
        plugins: "link lists image code table wordcount preview hr fullscreen ",
        toolbar1:
          " fontsizeselect alignleft aligncenter alignright alignjustify bullist numlist outdent indent undo redo link unlink image code removeformat preview hr quickbars fullscreen importword",
        toolbar2:
          " table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
        lineheight_formats: "1 1.1 1.2 1.3 1.4 1.5 2 2.1 2.2 2.3 2.4 2.5",

        images_upload_handler: function (blobInfo, succFun, failFun) {
          var xhr, formData;
          var file = blobInfo.blob(); //转化为易于理解的file对象
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open("POST", "https://xbhzhyl.com.cn/api/user/getPicUrl");
          xhr.onload = function () {
            if (xhr.status != 200) {
              failFun("HTTP Error: " + xhr.status);
              return;
            }
            succFun(JSON.parse(xhr.responseText).item);
          };
          formData = new FormData();
          formData.append("file", file, file.name); //此处与源文档不一样
          xhr.send(formData);
        },
        // importword_handler: function (editor, files, next) {
        //   var file_name = files[0].name;
        //   if (file_name.substr(file_name.lastIndexOf(".") + 1) == "docx") {
        //     editor.notificationManager.open({
        //       text: "正在转换中...",
        //       type: "info",
        //       closeButton: false,
        //     });
        //     next(files);
        //   } else {
        //     editor.notificationManager.open({
        //       text: "目前仅支持docx文件格式，若为doc111，请将扩展名改为docx",
        //       type: "warning",
        //     });
        //   }
        //   // next(files);
        // },
        // importword_filter: function (result, insert) {
        //   // 自定义操作部分
        //   insert(result); //回插函数
        // },
      },
    };
  },
  mounted() {
    // 初始化
    tinymce.init({});
    // 阻止默认行为
    // document.body.ondrop = function (event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // };
    // this.rowDrop();
    // this.columnDrop();
    // 获取新闻
    this.getNews();
    // 验证token
    this.verifyToken();
  },
  methods: {
    // 打开dialog添加新闻
    openAddNewsDialog() {
      this.type = "add";
      this.dialogTitle = "添加新闻";
      this.dialogBtn = "确认添加";
      this.dialogVisible = true;
      this.form = { title: "", startTime: "", dataes: "" };
    },
    // 打开dialog修改新闻
    openChangeNewsDialog(row) {
      this.type = "change";
      this.dialogTitle = "修改新闻";
      this.dialogBtn = "确认修改";
      this.dialogVisible = true;
      // 直接赋值会被浅拷贝
      this.form = JSON.parse(JSON.stringify(row));
    },
    // 获取新闻
    getNews() {
      let query = this.$qs.stringify({
        limit: this.limit,
        page: this.page,
        type: "2",
      });
      getNewsList(query).then((res) => {
        if (res.data.code == 200) {
          this.total = res.data.item.count;
          this.tableData = res.data.item.item;
        } else {
          this.$router.push({ path: "/Login" });
          this.$message({
            type: "warning",
            message: "登录超时，请重新登录",
          });
        }
      });
    },
    // 分页回调
    handleCurrentChange(val) {
      this.page = val;
      this.getNews();
    },
    // 删除新闻
    delNews(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delNews(id).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功！",
              });
              this.reload();
            } else {
              this.$message({
                type: "warning",
                message: "删除失败，" + res.data.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    // 提交
    submit(type) {
      if (!this.form.title) {
        this.$message({
          type: "warning",
          message: "请输入新闻详情",
        });
        return;
      }
      if (!this.form.startTime) {
        this.$message({
          type: "warning",
          message: "请输入日期",
        });
        return;
      }
      if (!this.form.dataes) {
        this.$message({
          type: "warning",
          message: "请输入新闻内容",
        });
        return;
      }
      const query = this.$qs.stringify({
        id: this.form.id,
        title: this.form.title,
        startTime: this.form.startTime,
        dataes: this.form.dataes,
      });
      // 添加
      if (type == "add") {
        addNews(query).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "添加成功！",
            });
            // this.getNews();
            this.reload();
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "warning",
              message: "添加失败，" + res.data.message,
            });
          }
        });
      }
      // 修改
      else if (type == "change") {
        updateNews(query).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功！",
            });
            // this.getNews();
            this.reload();
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "warning",
              message: "修改失败，" + res.data.message,
            });
          }
        });
      }
    },
    // 验证token 不允许直接访问
    verifyToken() {
      let axData = JSON.parse(sessionStorage.getItem("axData"));
      if (!axData) {
        this.$message({
          type: "warning",
          message: "请先登录",
        });
        this.$router.push({ path: "/Login" });
      }
    },
    // //行拖拽
    // rowDrop() {
    //   const tbody = document.querySelector(".el-table__body-wrapper tbody");
    //   const _this = this;
    //   Sortable.create(tbody, {
    //     onEnd({ newIndex, oldIndex }) {
    //       const currRow = _this.tableData.splice(oldIndex, 1)[0];1
    //       _this.tableData.splice(newIndex, 0, currRow);
    //     },
    //   });
    // },
    // //列拖拽
    // columnDrop() {
    //   const wrapperTr = document.querySelector(".el-table__header-wrapper tr");
    //   this.sortable = Sortable.create(wrapperTr, {
    //     animation: 180,
    //     delay: 0,
    //     onEnd: (evt) => {
    //       const oldItem = this.dropCol[evt.oldIndex];
    //       this.dropCol.splice(evt.oldIndex, 1);
    //       this.dropCol.splice(evt.newIndex, 0, oldItem);
    //     },
    //   });
    // },
  },
};
</script>
<style lang="less" scoped>
#Edit {
  width: 90vw;
  height: 100vh;
  background-color: #f0f0f0;
  h2 {
    text-align: center;
    font-size: 0.425rem;
    line-height: 1.8rem;
  }
  .EditTable {
    width: 80%;
    height: 6.5rem;
    background-color: #fff;
    box-shadow: 0 0 10px #ccc;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    .EditTable_AddBtn {
      height: 1rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0 0.5rem;
      a {
        text-decoration: none;
        color: #fff;
      }
    }
    .EditMain {
      height: 4.5rem;
    }
    .EditPagination {
      width: 100%;
      height: 0.5rem;
      display: flex;
      justify-content: center;
      margin-top: 0.28rem;
    }
  }
}
</style>
<style lang="less">
.el-icon-warning {
  font-size: 20px;
}
.el-icon-success {
  font-size: 20px;
}
.el-dialog {
  .el-dialog__header {
    display: flex;
    button {
      font-size: 0.3rem;
    }
  }
  .el-dialog__body {
    padding: 0 20px 10px 20px;
    .el-form {
      width: 100%;
      .el-form-item__label {
        width: 100%;
        text-align: left;
      }
      .el-form-item {
        &:last-child {
          margin-top: 0.2rem;
          display: flex;
          justify-content: center;
        }
      }
    }
  }
}

.tox-tinymce-aux {
  z-index: 999999 !important;
}
</style>
